export enum GalleryStyleType {
  STYLE_1,
  STYLE_2,
  STYLE_3
}
